export type GetConfigurationOptions = {
  /**
   * Feature flags from the API (e.g. from useFeatureFlags().flags).
   * Used by ca-v4 to conditionally include tasks such as Expectations.
   */
  featureFlags?: Record<string, unknown>;
};

/**
 * Given a `region`, return lazily the matching configuration.
 * For ca-v4, pass `featureFlags` so the config can include/exclude tasks (e.g. Expectations).
 */
export async function getConfiguration(
  onboardingConfigurationId: string,
  options?: GetConfigurationOptions,
) {
  const featureFlags = options?.featureFlags ?? {};

  switch (onboardingConfigurationId) {
    /*** California ***/
    /** @deprecated please use `ca-ukg-swing-cert` instead */
    case "ca":
      return (await import("./ca")).CaliforniaConfiguration;
    /** @deprecated please use `ca-ukg-swing-cert` instead */
    case "ca-ukg":
      return (await import("./ca-ukg")).CaliforniaUKGConfiguration;
    case "ca-ukg-swing-cert":
      return (await import("./ca-ukg-swing-cert")).CaliforniaUKGSwingCertConfiguration;
    case "ca-v4":
      return (await import("./ca-v4")).getCaliforniaV4Configuration(featureFlags);
    /*** New Jersey ***/
    case "nj":
      return (await import("./nj")).NewJerseyConfiguration;
    /*** Fallback ***/
    default: {
      throw new Error(`No configuration found for ${onboardingConfigurationId}`);
    }
  }
}
